import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ModalComponent } from "components/modal/modal.component";
import { DeviceDetectorService } from "ngx-device-detector";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { lastValueFrom } from "rxjs";
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { StatusJornada } from "src/app/shared/enums/Jornada/StatusJornada";
import { Escola } from "src/app/shared/models/escola/Escola";
import { RotaMaps } from "src/app/shared/models/maps/rota.model";
import { FimJornada, JornadaPsicologo } from "src/app/shared/models/psicologo/JornadaPsicologo";
import { UserLoginSed } from "src/app/shared/models/sed/UserLogin";
import { EscolaService } from "src/app/shared/services/escola.service";
import { MapsService } from "src/app/shared/services/maps.service";
import { RelogioPontoService } from "src/app/shared/services/modal-relogioPonto.service";
import { PsicologoService } from "src/app/shared/services/psicologo.service";
import { Perfil } from "src/app/shared/enums/Perfis/Perfis";

@Component({
    selector: 'modal-registro-fim-jornada',
    templateUrl: './modal-registro-fim.component.html',
    styleUrls: ['./modal-registro-fim.component.scss'],
    standalone: true,
    imports:[FormsModule,CommonModule,ModalComponent,ReactiveFormsModule]
})
export class ModalRegistroFimComponent {
  showModal = false;
  submmited = false;
  userLogado: UserLoginSed | null;
  // @Output() OnClose = new EventEmitter<void>();

  escolaService = inject(EscolaService);
  toastr = inject(ToastrService);
  deviceService = inject(DeviceDetectorService);
  spinner = inject(NgxSpinnerService);
  psicologoService = inject(PsicologoService);
  relogioPontoService = inject(RelogioPontoService);
  authService = inject(AuthService);
  router = inject(Router);
  mapsService = inject(MapsService);

  escola: Escola;
  device: string;
  longitude: string;
  latitude: string;
  JornadaAtiva: JornadaPsicologo | null;
  mensagemRetornoSucesso: string = '';


  deslocamento: RotaMaps | undefined;
  qtdeCaracteresJustificativaDistancia: number = 0;
  disabledJustificativaDistancia: boolean = false;
  formDeslocamento: FormGroup;

  public get justificativaDistancia() {
    return this.formDeslocamento.get('justificativaDistancia')!;
  }

  async ngOnInit() {
    // this.getUserLogado();
    // await this.getEscolaAtual();
    // await this.getLocation();
    this.formDeslocamento = new FormGroup({
      justificativaDistancia: new FormControl('', [Validators.required, Validators.minLength(10),
      Validators.maxLength(500)])
    });


    this.relogioPontoService.modalFinalizarJornada$.subscribe(async (data) => {
      this.spinner.show();

      if (data) {
        this.getUserLogado();
        await this.getJornadaEmAberto();
        await this.getEscolaAtual();
        await this.getLocation();
      }

      this.showModal = data && this.mensagemRetornoSucesso === '';
      this.spinner.hide();
    });
  }

  closeModal() {
    this.showModal = false;
    this.formDeslocamento.get('justificativaDistancia')?.setValue('')
    this.relogioPontoService.fecharModalFinalizarJornada();
  }

  async getEscolaAtual() {
    var codigoEscola = this.JornadaAtiva ? this.JornadaAtiva.codigoEscola : this.userLogado?.codigoEscola;
    if (codigoEscola != 0) {
      const response = await lastValueFrom(this.escolaService.getEscolaDetalhes(codigoEscola!));
      if (!response.isSucess) {
        this.toastr.error(response.message);
        return;
      }
      this.escola = response.data;
    } else {
      const responseDiretoria = await lastValueFrom(this.escolaService.getDiretoriaPorCodigo(this.userLogado?.codigoDiretoria!));
      if (!responseDiretoria.isSucess) {
        this.toastr.error(responseDiretoria.message, responseDiretoria.title);
        this.spinner.hide();
        return;
      }
      var diretoria = responseDiretoria.data[0];
      if (responseDiretoria.data) {
        if (!this.escola) {
          this.escola = new Escola();
        }
        this.escola.codigoDiretoria = diretoria.codigoDiretoria;
        this.escola.nomeDiretoria = diretoria.nomeDiretoria;
        this.escola.latitude = diretoria.latitude;
        this.escola.longitude = diretoria.longitude;
        this.escola.codigoEscola = 0;
        this.escola.nomeEscola = '';
      }
    }
  }

  async getLocation(): Promise<void> {

    const deviceInfo = this.deviceService.getDeviceInfo();

    // if(deviceInfo.deviceType === 'desktop'){
    //   this.toastr.error(`Geolocalização não suportada em dispositivos Desktop.`);
    //   console.error('Geolocalização não suportada em dispositivos Desktop.');
    //   return;
    // }

    if ('connection' in navigator) {
      const connection = (navigator as any).connection;
    }

    if ('geolocation' in navigator) {
      // Configurações para alta precisão
      const options: PositionOptions = {
        enableHighAccuracy: true, // Ativa alta precisão
        timeout: 5000, // Tempo máximo de espera
        maximumAge: 0, // Não usar cache
      };

      // Solicita a localização
      await navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {

          this.latitude = position.coords.latitude.toString();
          this.longitude = position.coords.longitude.toString();
          this.device = deviceInfo.deviceType;

          // this.toastr.success(`Lat: ${position.coords.latitude}, Long: ${position.coords.longitude}`);
        },
        (error: GeolocationPositionError) => {
          this.toastr.error(`Erro ao obter a localização: ${error.message}`);
          console.error(error); // Retorna o erro
        },
        options
      );

    } else {
      this.toastr.error(`Geolocalização não suportada neste navegador.`);

      console.error('Geolocalização não suportada neste navegador.');
    }
  }

  async getJornadaEmAberto() {
    this.spinner.show();
    const response = await lastValueFrom(this.psicologoService.getJornadaEmAberto(this.userLogado?.cpf!));
    if (!response.isSucess) {
      this.toastr.error(response.message, response.title);
      this.spinner.hide();
      return;
    }
    this.JornadaAtiva = response.data;

    // Verifica se existem jornadas neste dia
    const responseDia = await lastValueFrom(this.psicologoService.getJornadas(this.userLogado?.codigoPolo!, undefined, undefined, this.userLogado?.cpf!));
    var totalHorasJornada = 0;
    if (!responseDia.isSucess) {
      this.toastr.error(responseDia.message, responseDia.title);
      this.spinner.hide();
      return;
    }
    if (responseDia.data.length > 0) {
      //filtra jornadas del dia de hoy del responseDia com data fim diferente de null
      const jornadaDia = responseDia.data.filter((x: { dataInicio: string, dataFim: string }) => {
        const dataInicio = new Date(x.dataInicio);
        const dataFim = new Date(x.dataFim);
        const hoje = new Date();
        return dataInicio.getDate() === hoje.getDate() &&
          dataInicio.getMonth() === hoje.getMonth() &&
          dataInicio.getFullYear() === hoje.getFullYear() &&
          x.dataFim && dataFim.getDate() != null;
      });
      //calcula a diferença de horas entre dataFim e dataInicio
      for (var i = 0; i < jornadaDia.length; i++) {
        // Converta as strings de data para objetos Date
        const dataFim = new Date(jornadaDia[i].dataFim);
        const dataInicio = new Date(jornadaDia[i].dataInicio);
        // Calcule a diferença em milissegundos
        const diferencaEmMilissegundos = dataFim.getTime() - dataInicio.getTime();
        // Converta a diferença para horas
        const horas = diferencaEmMilissegundos / (1000 * 60 * 60);
        totalHorasJornada += horas; // Acumula as horas totais
      }
    }

    // Verifica se existem deslocamentos no dia de hoje
    const responseDeslocamento = await lastValueFrom(this.psicologoService.getJornadasDeslocamentos(this.userLogado?.cpf!));
    if (!responseDeslocamento.isSucess) {
      this.toastr.error(responseDeslocamento.message, responseDeslocamento.title);
      this.spinner.hide();
      return;
    }
    //filtra jornadas del dia de hoy del responseDeslocamento com data fim diferente de null
    if (responseDeslocamento.isSucess && responseDeslocamento.data.length > 0) {
      //calcula a diferença de horas entre dataFim e dataInicio
      for (var i = 0; i < responseDeslocamento.data.length; i++) {
        // Converta as strings de data para objetos Date
        const horarioChegada = responseDeslocamento.data[i].horarioChegada;
        const horarioSaida = responseDeslocamento.data[i].horarioSaida;
        const horarioSaidaPadronizado = horarioSaida.includes(':') ? `${horarioSaida}:00` : horarioSaida;
        const [horaChegada, minutoChegada, segundoChegada] = horarioChegada.split(':').map(Number);
        const [horaSaida, minutoSaida, segundoSaida] = horarioSaidaPadronizado.split(':').map(Number);
        const dataChegada = new Date();
        dataChegada.setHours(horaChegada, minutoChegada, segundoChegada, 0);
        const dataSaida = new Date();
        dataSaida.setHours(horaSaida, minutoSaida, segundoSaida || 0, 0);
        // Calcule a diferença em milissegundos
        const diferencaEmMilissegundos = dataChegada.getTime() - dataSaida.getTime();
        // Converta a diferença para horas
        const horas = diferencaEmMilissegundos / (1000 * 60 * 60);
        totalHorasJornada += horas; // Acumula as horas totais
      }
    }

    if (response.data !== null) {
      this.JornadaAtiva = response.data;
      var dataInicioJornada = new Date(response.data.dataInicio);
      var diferenciaEmHoras = new Date().getTime() - dataInicioJornada.getTime();
      var diferencaEmHoras = diferenciaEmHoras / (1000 * 60 * 60);
      var diaDiferenca = new Date().getDate() - dataInicioJornada.getDate();
      //Revisa si existe diferencia de dias
      if (diaDiferenca > 0) {
        this.mensagemRetornoSucesso = `Jornada maior que 1 dia, iniciada as ${this.JornadaAtiva!.horaInicio}`;
        this.toastr.warning('Check-out do último dia trabalhado ainda não realizado. Favor efetuar o acerto na tela de Painel de Atividade do Psicólogo');
        return;
      }
      totalHorasJornada = totalHorasJornada + diferencaEmHoras;
      //Revisa si existe diferencia de horas maior que 10
      if (totalHorasJornada > 10) {
        this.toastr.warning('Horas trabalhadas superior a 10 horas/dia, registro de saída não autorizado. Efetuar o acerto no Painel de Atividade do Psicólogo');
      }
    }
    this.spinner.hide();
  }

  async registraFimJornada() {
    this.spinner.show();

    const limiteDistanciaKm = 1;
    const limiteDistanciaMetros = limiteDistanciaKm * 1000;

    if ((this.userLogado?.autorizacaoUsoDados == 1) && await this.validarLatLong()) {
      this.deslocamento = await this.mapsService.calculateDistance(
        +this.latitude!, +this.longitude!,
        +this.escola!.latitude, +this.escola!.longitude,
        false);
    }

    if (this.deslocamento &&
      this.deslocamento?.totalKm! > limiteDistanciaMetros &&
      this.justificativaDistancia?.value.length < 10 ||
      this.justificativaDistancia?.value > 500) {
      this.disabledJustificativaDistancia = false;
      this.toastr.warning("A justificativa deve ser no mínimo 10 caracteres e no maximo 500.");
      this.spinner.hide();
      this.submmited = false;
      return;
    }

    if (this.formDeslocamento.invalid && this.deslocamento?.totalKm! > limiteDistanciaMetros) {
      this.toastr.warning("Justifique sua distancia da escola");
      this.spinner.hide();
      return;
    }

    this.submmited = true;
    const body = await this.SetBodyParameters()

    if(this.userLogado?.codigoPerfil == Perfil.CoordenadorPsicologo){
      
      const polo = await lastValueFrom(this.psicologoService.getPoloPsicologo(this.userLogado?.cpf!));
      if (!polo.isSucess) {
        this.toastr.error(polo.message, polo.title);
        return;
      }

      if(!body.codigoPolo){
        body.codigoPolo = polo.data.codigoPolo;
      }

    }

    const response = await lastValueFrom(this.psicologoService.registraFimJornada(body));
    if (!response.isSucess) {
      this.toastr.error(response.message, response.title);
      this.relogioPontoService.updateStatusJornada(StatusJornada.ComErro);
      this.spinner.hide();
      this.submmited = false;
      return;
    }

    this.relogioPontoService.updateStatusJornada(StatusJornada.Finalizada);
    this.spinner.hide();
    this.submmited = false;
    const codigoJornada = this.JornadaAtiva?.codigoJornada;
    this.closeModal();
    // CA07: após encerrar a jornada pendente, permitir iniciar uma nova imediatamente.
    // O redirecionamento automático para "registro-saida" interrompia o fluxo e fazia o usuário ficar "preso" com mensagem de jornada em aberto.
    this.toastr.success("Saída registrada com sucesso! Você já pode iniciar uma nova jornada.", "Sucesso!");
    this.relogioPontoService.suprimirPromptDeslocamentoNoProximoInicioJornada();
    setTimeout(() => this.relogioPontoService.abrirModalIniciarJornada(), 0);
  }

  /** Evita serializar Date em UTC no JSON (desloca a hora no backend). */
  private formatDataFimLocalParaApi(d?: Date | string): string | undefined {
    if (!d) {
      return undefined;
    }

    const data = d instanceof Date ? d : new Date(d);
    if (Number.isNaN(data.getTime())) {
      return undefined;
    }

    const pad = (n: number) => String(n).padStart(2, '0');
    return `${data.getFullYear()}-${pad(data.getMonth() + 1)}-${pad(data.getDate())}T${pad(data.getHours())}:${pad(data.getMinutes())}:00`;
  }

  async SetBodyParameters(): Promise<FimJornada> {


    if ((this.userLogado?.autorizacaoUsoDados == 1) && await this.validarLatLong()) {
      this.deslocamento = await this.mapsService.calculateDistance(
        +this.latitude!, +this.longitude!,
        +this.escola.latitude, +this.escola.longitude,
        false);

    }
    const body: FimJornada = {
      codigoJornada: this.JornadaAtiva?.codigoJornada!,
      nomeUsuario: this.userLogado?.nome!,
      codigoUsuario: Number(this.userLogado?.cpf!),
      tipoRegistro: 1,
      latitude: this.userLogado?.autorizacaoUsoDados == 1 ? this.latitude : undefined,
      longitude: this.userLogado?.autorizacaoUsoDados == 1 ? this.longitude : undefined,
      distanciaEscola: this.deslocamento?.totalKmFormatado,
      tempoDeslocamento: this.deslocamento?.totalDuration,
      cpfPsicologo: this.userLogado?.cpf,
      codigoPolo: this.userLogado?.codigoPolo,
      dataFim: this.formatDataFimLocalParaApi(this.relogioPontoService.dataFim),
      justificativaDistanciaSaida: this.formDeslocamento.get('justificativaDistancia')?.value,
      NrCpfCoordenador: this.userLogado?.codigoPerfil == Perfil.CoordenadorPsicologo ? this.userLogado?.cpf : undefined,
      FlCoordenador: this.userLogado?.codigoPerfil == Perfil.CoordenadorPsicologo ? true : undefined

    }
    return body;
  }

  getUserLogado() {
    this.userLogado = this.authService.getUser();
    if (!this.userLogado)
      this.router.navigate(['/logout']);

  }

  public async validarLatLong(): Promise<boolean> {
    if (!this.longitude || !this.latitude)
      return false;

    if (
      this.escola &&
      +this.escola.latitude != 0 &&
      +this.escola.longitude != 0 &&
      +this.latitude != 0 &&
      +this.longitude != 0) {
      return true;
    }

    if(this.userLogado?.apenasDiretoria) {
      return true;
    }

    if (this.escola.latitude && +this.escola.latitude == 0
      && this.escola.longitude && +this.escola.longitude == 0) {
      this.toastr.error(`A Escola ${this.escola.nomeEscola} está com problema na Lat/Long ... `, 'Atenção!');
    }

    if (this.latitude && +this.latitude == 0
      && this.longitude && +this.longitude == 0) {
      this.toastr.error(`Há um problema na sua Lat/Long ... `, 'Atenção!');
    }

    return false;
  }
}
